const DEFAULT_API_BASE_URL = "/api/v1";

const trimTrailingSlashes = (value) => value.replace(/\/+$/, "");

const normalizeApiBaseUrl = (value) => {
  if (!value) return DEFAULT_API_BASE_URL;

  const trimmedValue = trimTrailingSlashes(value.trim());

  if (!trimmedValue) return DEFAULT_API_BASE_URL;
  if (/\/api\/v\d+$/i.test(trimmedValue) || /\/v\d+$/i.test(trimmedValue)) {
    return trimmedValue;
  }
  if (/\/api$/i.test(trimmedValue)) {
    return `${trimmedValue}/v1`;
  }

  return trimmedValue;
};

export const apiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);

export const storefrontCompanySlug =
  process.env.REACT_APP_STOREFRONT_COMPANY_SLUG || "blackandwhite";

export const resolveApiUrl = (path = "") => {
  if (!path) return apiBaseUrl;
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
};

export const prepareAuthHeaders = (headers, options = {}) => {
  const token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("token")
      : null;

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  if (options.acceptJson && !headers.has("accept")) {
    headers.set("accept", "application/json");
  }

  if (options.contentTypeJson && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }

  return headers;
};
